import React from "react";
import styled from "styled-components";
import Spinner from "./Spinner";

const SecondaryButton = ({ title, onClick, loading, className, style }) => {
  return (
    <Wrapper onClick={onClick} className={`w-100 py-2 w-full rounded outline-0 border-0 bg-primary2 text-center ${className}`} style={style}>
      {loading ? <Spinner size={25} /> : <span className="text-center text-white fs-nromal">{title}</span>}
    </Wrapper>
  );
};

export default SecondaryButton;
const Wrapper = styled.button``;
